var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "newSizeSelectionModal",
    attrs: {
      "modal-name": "newSizeSelectionModal",
      "click-to-close": false,
      "show-close-icon": false,
      "cta-primary-button": "sizeSelectionContinue"
    },
    on: {
      "cta-action": _vm.onContinue,
      "closed": _vm.resetSelectField
    }
  }, [_c('div', {
    staticClass: "new-size-selection-content"
  }, [_c('h2', {
    staticClass: "text-center new-size-selection-title"
  }, [_vm._v(_vm._s(_vm.translations.sizeSelectionHeader))]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "CTA-wrapper row"
  }, [_c('div', {
    staticClass: "columns small-10 small-offset-1"
  }, [_c('select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.areSizesLoaded,
      expression: "areSizesLoaded"
    }, {
      name: "model",
      rawName: "v-model",
      value: _vm.sizeSelected,
      expression: "sizeSelected"
    }],
    staticClass: "ugc-main-select-size-selector",
    attrs: {
      "name": "customizer-ugc-main-size",
      "data-menu-id": "1"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.sizeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, function ($event) {
        return _vm.onSelect();
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.translations.selectText) + " ")]), _vm._l(_vm.sizes.values, function (value, index) {
    return _c('option', {
      key: value,
      domProps: {
        "value": _vm.sizes.identifier[index]
      }
    }, [_vm._v("\n              " + _vm._s(value) + "\n            ")]);
  })], 2)])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }